<template>
  <div class="main-action-wrap">
    <div class="action-title">开卡即享超值权益</div>
    <van-field
      v-model="inputValue"
      placeholder="请输入手机号"
      class="action-input"
      :maxlength="11"
    />
    <div class="action-btn">
      <div class="btn-value">
        <span class="btn-value-text">首月</span>
        <span class="btn-value-unit">¥</span>
        1
      </div>
      <div class="btn-text" @click="activeMember">立即开卡</div>
    </div>
    <div class="action-desc">
      <p>
        次月起按9.9元自动续费，可随时取消，<span
          class="link"
          @click="openRulePopup"
          >详细开通规则</span
        >
      </p>
      <div class="agree-wrap">
        <van-radio
          v-model="isAgree"
          class="radio-wrap"
          :icon-size="14"
          name="1"
        />
        我已阅读并同意<span class="link" @click="showArgument"
          >《服务协议》</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "@vue/composition-api";
import Vue from "vue";

import { signByPhone, queryMemberCardInfo } from "@/apis/product";
import { useRoute } from "@/components/use/base";

const vm = Vue.prototype;

export default defineComponent({
  props: ["openRulePopup"],

  setup() {
    const route = useRoute();
    const { channel_source, auth_code } = route.query;

    const inputValue = ref("");
    const isAgree = ref(false);

    const showArgument = () => {
      location.href = "https://cdn.xiangshuheika.com/h5/agreement/xssqk.html";
    };

    const activeMember = async () => {
      if (!/^1[3-9]\d{9}$/.test(inputValue.value)) {
        vm.$toast("请输入正确的手机号");
        return;
      }
      if (!inputValue.value) {
        vm.$toast("请输入手机号");
        return;
      }
      if (!isAgree.value) {
        vm.$toast("请先阅读并同意服务协议");
        return;
      }
      const { data } = await queryMemberCardInfo({
        phone_number: inputValue.value,
        access_code: auth_code,
      });
      const cardList = data?.card_list || [];
      const openId = data?.open_id || "";
      const arr = cardList?.filter((item) => !item.is_active) || [];
      if (arr.length === 0) {
        vm.$toast("当日会员卡已售罄，请次日重试");
        return;
      }
      const { data: signData } = await signByPhone({
        phone_number: inputValue.value,
        namespace: arr[0].namespace_name,
        item_code: arr[0].package_name,
        source: channel_source || "default",
        open_id: openId,
        access_code: auth_code,
      });
      window.location.href = signData.sign_url;
    };

    return {
      inputValue,
      isAgree,
      showArgument,
      activeMember,
    };
  },
});
</script>

<style lang="less" scoped>
.main-action-wrap {
  margin: 0 12px;
  height: 223px;
  background: #fff7ec;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 16px 12px 9px 12px;
  margin-top: 30px;

  .action-title {
    font-weight: 600;
    font-size: 18px;
    color: #222222;
    line-height: 22px;
    text-align: center;
  }

  .action-input {
    margin-top: 16px;
    border-radius: 8px;
    height: 40px;

    /deep/ .van-field__control {
      line-height: 20px;
      text-align: center;
    }
  }

  .action-btn {
    margin-top: 24px;
    height: 52px;
    background: url("../../../assets/images/btn-bg.png") no-repeat;
    background-size: 100%;
    border-radius: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .btn-value {
    color: #ffe29e;
    width: 153px;
    font-size: 24px;
    text-align: center;
    padding-bottom: 5px;
    > span {
      font-size: 12px;
      margin: 2px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .btn-text {
    width: 153px;
    font-size: 18px;
    height: 24px;
    line-height: 24px;
    color: #642407;
    text-align: center;
    font-weight: 500;
    line-height: 25px;
  }

  .action-desc {
    margin-top: 8px;
    font-weight: 400;
    font-size: 10px;
    color: #999999;
    line-height: 16px;
    text-align: center;

    .link {
      color: #0170fe;
    }

    .agree-wrap {
      display: flex;
      justify-content: center;
      margin-top: 4px;

      .radio-wrap {
        margin-right: 4px;
      }
    }
  }
}
</style>
